import PageContainer from 'components/common/PageContainer/PageContainer';
import SettingHeader from 'components/Settings/Components/SettingHeader/settingHeader';
import { settingsConfig } from 'components/Settings/settingsConfig';
import { useFullStoryPageView } from 'hooks/useFullstoryPageView';
import { HeaderWrapper } from 'components/common/PageContainer/HeaderWrapper';
import { MainContent } from 'components/common/PageContainer/MainContent';
import { UserGroupsEdit } from 'components/Settings/Components/UserGroups/components/userGroupsEdit';

export const UserGroupsEditPage = () => {
    useFullStoryPageView({ pageName: settingsConfig.userGroupsEdit.title });

    return (
        <PageContainer>
            <HeaderWrapper>
                <SettingHeader
                    title={settingsConfig.userGroupsEdit.title}
                    subTitle={'Add & edit User Groups'}
                    isBackArrow={true}
                />
            </HeaderWrapper>
            <MainContent>
                <UserGroupsEdit />
            </MainContent>
        </PageContainer>
    );
};
